import styled from "styled-components";
import { Container, Section } from "components/shared";
import respondTo from "util/respondTo";

export const NewSection = styled(Section)``;

export const AboutContainer = styled(Container)`
    display: flex;
    align-items: center;

    ${respondTo.sm`
        flex-direction:column;
        justify-content:center;
    `}
`;

export const Self = styled.img`
    border-radius: 50%;
    width: 11rem;
    height: 11rem;
    display: block;
    margin-right: 1.5rem;
    object-fit: cover;

    ${respondTo.sm`
       margin-bottom:2rem;
    `}
`;

export const AboutMe = styled.p`
    line-height: 1.5;
`;
